export default __webpack_public_path__ + "static/media/blogimage6.8faa662a.png";